import FieldConfig from "../../../../proto/field-config";
import FieldDate from "../../../../generic/datetime/date/date";
import Task from "../../../../../model2/task/task";
import ItemModel from "../../../../../model2/item/item-model";
import Moment from "moment";
import FieldTaskEndDate_Popover from "./components/popover/popover";
import TableManager from "../../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../../gd-modules/task-list/manager/manager";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";
import {ViewType} from "../../../../../gd/const/views/view-type";
import GanttChartManager from "../../../../../gd-modules/gantt-chart/manager/manager";


export default class FieldTaskEndDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-end'
        this.label              = 'End date'

        this.minDate            = Moment()


        this.fieldParams.highlightIfPastdue         = false
        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange

        this.components.PopoverMenu                 = FieldTaskEndDate_Popover
    }


    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeEndDate
    }

    // Custom Methods

    tableCellOnValueChange = (item:ItemModel, value:any, manager:TableManager|TaskListManager|GanttChartManager) => {
        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const newStartDate = item.task.startDate ? item.task.startDate : value
                const newEndDate = value

                const ganttManager = manager as GanttChartManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                item.task.updateEndDate(value)
                item.task.save()

                item._updateLastUpdateTime() // otherwise it wont re-render

                manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])
                break
        }
    }

}
